module.exports = __webpack_public_path__ + "static/media/SuccesfullIcon.b2a7d1fd.svg";